<script setup>
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import {Separator} from "@/components/ui/separator";
import {RouterLink, useRoute, useRouter} from 'vue-router'
import {cn} from "@/lib/utils.js";
import {Button} from "@/components/ui/button/index.js";
import {computed} from "vue";
import {Platforms} from "@/enums.js";

const $route = useRoute()
const $router = useRouter()

const props = defineProps({
  organisation: {
    type: Object,
    required: false,
    default: null
  },

  app: {
    type: Object,
    required: false,
    default: null
  }
});

const platformName = computed(() => {
  return props.app ? Platforms.toString(props.app.platform) : '';
});
</script>

<template>
  <div class="container">
    <div class="hidden space-y-6 md:block" v-if="organisation">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <RouterLink to="/">Companies</RouterLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator/>
          <BreadcrumbItem>
            <RouterLink :to="{name: 'OrganisationDashboard', params: {organisationId: organisation.id}}">{{ organisation.name }}</RouterLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator/>
          <BreadcrumbItem>
            <BreadcrumbPage>{{ app?.name || 'Loading...' }}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>

    <div class="space-y-0.5">
      <h2 class="text-2xl font-bold tracking-tight">
        {{ app?.name || 'Loading...' }}
      </h2>
      <p class="text-muted-foreground pb-6">
        {{ platformName }}
      </p>

      <Separator class="my-6"/>

      <div class="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">
        <aside class="w-1/5 pt-6">
          <nav class="flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1">
            <Button
                @click="$router.push({path: `/${$route.params.organisationId}/app/${$route.params.appId}`})"
                variant="ghost"
                :class="cn(
        'w-full text-left justify-start',
        $route.path === `/${$route.params.organisationId}/app/${$route.params.appId}` && 'bg-muted hover:bg-muted',
      )">
              Panels
            </Button>

            <Button
                @click="$router.push({path: `/${$route.params.organisationId}/app/${$route.params.appId}/analytics`})"
                variant="ghost"
                :class="cn(
        'w-full text-left justify-start',
        $route.path === `/${$route.params.organisationId}/app/${$route.params.appId}/analytics` && 'bg-muted hover:bg-muted',
      )">
              Analytics
            </Button>

            <Button
                @click="$router.push({path: `/${$route.params.organisationId}/app/${$route.params.appId}/settings`})"
                variant="ghost"
                :class="cn(
        'w-full text-left justify-start',
        $route.path === `/${$route.params.organisationId}/app/${$route.params.appId}/settings` && 'bg-muted hover:bg-muted',
      )">
              Settings
            </Button>
          </nav>
        </aside>
        <div class="flex-1">
          <div class="space-y-6">
            <slot/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>